import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import Select from 'react-select'
import { useForm } from 'react-hook-form'
import axios from 'axios'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

function AddBatch({ onClose }) {
  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const daysOfWeek = [
    'Saturday',
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
  ]
  const [selectedDays, setSelectedDays] = useState([])
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())

  const handleDayToggle = (day) => {
    setSelectedDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    )
  }

  function generateError(err) {
    return toast.error(err, {
      position: 'top-center',
    })
  }

  const onSubmit = async (values) => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}savebatch`,
        {
          ...values,
          id: 0,
          start_date: startDate,
          end_date: endDate,
        },
        {
          withCredentials: true,
        }
      )

      console.log(data)

      if (data) {
        if (data.errors) {
          const { name, email, password } = data.errors
          if (name) generateError(name)
          else if (email) generateError(email)
          else if (password) generateError(password)
        } else {
          //navigate("/batches");
          //window.location.reload(true);
        }
      }
    } catch (error) {
      console.log(error)
    }
    if (onClose) onClose()
  }

  return (
    <form
      className="w-full max-w-2xl mx-auto p-0"
      onSubmit={handleSubmit(onSubmit)}
      autoComplete="off"
    >
      <h2 className="text-2xl font-bold text-[#030303] mb-8">Add Batch</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label className="block text-[#030303] font-medium mb-2">
            Batch Code<span className="text-[#DE3C7D]">*</span>
          </label>
          <input
            type="text"
            className="w-full bg-[#FAFAFA] border-none rounded-xl px-5 py-3 text-[#030303] font-medium focus:ring-2 focus:ring-[#DE3C7D] outline-none"
            {...register('batch_code', { required: 'Batch Code is required' })}
          />
          {errors.batch_code && (
            <p className="text-[#DE3C7D] text-xs mt-1">
              {errors.batch_code.message}
            </p>
          )}
        </div>
        <div>
          <label className="block text-[#030303] font-medium mb-2">
            Batch Title<span className="text-[#DE3C7D]">*</span>
          </label>
          <input
            type="text"
            className="w-full bg-[#FAFAFA] border-none rounded-xl px-5 py-3 text-[#030303] font-medium focus:ring-2 focus:ring-[#DE3C7D] outline-none"
            {...register('batch_title', {
              required: 'Batch Title is required',
            })}
          />
          {errors.batch_title && (
            <p className="text-[#DE3C7D] text-xs mt-1">
              {errors.batch_title.message}
            </p>
          )}
        </div>
        <div>
          <label className="block text-[#535862] font-medium mb-2">
            Max Number of Students
          </label>
          <input
            type="number"
            className="w-full bg-[#FAFAFA] border-none rounded-xl px-5 py-3 text-[#030303] font-medium focus:ring-2 focus:ring-[#DE3C7D] outline-none"
            {...register('no_of_students')}
          />
        </div>
        <div></div>
        <div>
          <label className="block text-[#030303] font-medium mb-2">
            Start Date<span className="text-[#DE3C7D]">*</span>
          </label>
          <DatePicker
            className="w-full bg-[#FAFAFA] border-none rounded-xl px-5 py-3 text-[#030303] font-medium focus:ring-2 focus:ring-[#DE3C7D] outline-none"
            selected={startDate}
            onChange={setStartDate}
            dateFormat="MM/dd/yyyy"
          />
        </div>
        <div>
          <label className="block text-[#030303] font-medium mb-2">
            End Date<span className="text-[#DE3C7D]">*</span>
          </label>
          <DatePicker
            className="w-full bg-[#FAFAFA] border-none rounded-xl px-5 py-3 text-[#030303] font-medium focus:ring-2 focus:ring-[#DE3C7D] outline-none"
            selected={endDate}
            onChange={setEndDate}
            dateFormat="MM/dd/yyyy"
          />
        </div>
      </div>
      <div className="mb-8">
        <label className="block text-[#030303] font-medium mb-2">
          Select Days
        </label>
        <div className="flex flex-wrap gap-2">
          {daysOfWeek.map((day) => (
            <button
              type="button"
              key={day}
              className={`px-5 py-2 rounded-xl border text-sm font-medium transition-colors focus:outline-none min-w-[110px] whitespace-nowrap
                ${
                  selectedDays.includes(day)
                    ? 'bg-white border-2 border-[#DE3C7D] text-[#DE3C7D]'
                    : 'bg-white border border-[#E0E0E0] text-[#030303] hover:border-[#DE3C7D]'
                }
              `}
              onClick={() => handleDayToggle(day)}
            >
              {day}
            </button>
          ))}
        </div>
      </div>
      <div className="flex flex-col md:flex-row gap-4 mt-8">
        <button
          type="button"
          onClick={onClose}
          className="w-full md:w-1/2 px-4 py-3 rounded-xl border border-[#E0E0E0] text-[#030303] bg-white font-medium hover:bg-neutral-50 transition-colors"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="w-full md:w-1/2 px-4 py-3 rounded-xl bg-[#DE3C7D] text-white font-medium hover:bg-[#c8356f] transition-colors"
        >
          Submit
        </button>
      </div>
    </form>
  )
}

export default AddBatch
